import { DeleteResumeDto, ResumeDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";
import { trackEvent } from "@/client/utils/analytics";

export const deleteResume = async (data: DeleteResumeDto) => {
  const userId = useAuthStore.getState().user?.id;
  try {
    const response = await axios.delete<ResumeDto, AxiosResponse<ResumeDto>, DeleteResumeDto>(
      `/resume/${data.id}`,
    );
    trackEvent({
      userType: "youth",
      apiName: "deleteResume",
      userId,
      success: true,
      resourceId: data.id,
    });
    return response.data;
  } catch (error) {
    trackEvent({
      userType: "youth",
      apiName: "deleteResume",
      userId,
      success: false,
      resourceId: data.id,
    });
    throw error;
  }
};

export const useDeleteResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: deleteResumeFn,
  } = useMutation({
    mutationFn: deleteResume,
    onSuccess: (data) => {
      queryClient.removeQueries({ queryKey: ["resume", data.id] });

      queryClient.setQueryData<ResumeDto[]>(["resumes"], (cache) => {
        if (!cache) return [];
        return cache.filter((resume) => resume.id !== data.id);
      });
    },
  });

  return { deleteResume: deleteResumeFn, loading, error };
};
